(function () {
  var PRODUCTS_ENDPOINT = '/products.json?limit=250';
  var MAX_RECOMMENDATIONS = 6;
  var MAX_COLLECTORS = 6;
  var MAX_PRODUCT_FETCH = 24;
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var FOLLOW_LABEL = '팔로우';
  var FOLLOWING_LABEL = '팔로잉';
  var LIVE_COLLECTOR_EMPTY_MESSAGE = '지금 공구 중인 컬렉터가 없습니다.';

  function bootInteractiveWidgets(root) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    if (window.TownWineFollow && typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(root);
    }

    if (window.TownWineCollectorStats && typeof window.TownWineCollectorStats.init === 'function') {
      window.TownWineCollectorStats.init(root);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function extractCollectorHandleFromUrl(url) {
    var rawUrl = String(url || '').trim();

    if (!rawUrl) {
      return '';
    }

    try {
      var parsedUrl = new URL(rawUrl, window.location.origin);
      var pathParts = String(parsedUrl.pathname || '')
        .split('/')
        .filter(Boolean);

      if (pathParts.length >= 3 && pathParts[0] === 'pages' && pathParts[1] === 'collector') {
        return normalizeHandle(decodeURIComponent(pathParts[2] || ''));
      }
    } catch (error) {
      // Fall back to a regex parse for relative paths or malformed values.
    }

    var pathMatch = rawUrl.match(/\/pages\/collector\/([^/?#]+)/i);
    return normalizeHandle(pathMatch && pathMatch[1] ? decodeURIComponent(pathMatch[1]) : '');
  }

  function resolveCollectorIdentity(collector) {
    var followHandle = normalizeHandle(collector && collector.followHandle);
    var urlHandle = extractCollectorHandleFromUrl(collector && collector.collectorUrl);
    var handleLabel = normalizeHandle(collector && collector.handleLabel);
    var displayName = String(
      (collector && (collector.displayName || collector.followName)) || '',
    ).trim();
    var displayNameKey = normalizeHandle(displayName);
    var dedupeKey = followHandle || urlHandle || handleLabel || displayNameKey;
    var resolvedHandle = followHandle || urlHandle || handleLabel || '';

    return {
      dedupeKey: dedupeKey,
      followHandle: resolvedHandle,
      followName: String((collector && (collector.followName || displayName)) || '').trim(),
      displayName: displayName || resolvedHandle,
      handleLabel:
        String((collector && collector.handleLabel) || '').trim() ||
        (resolvedHandle ? '@' + resolvedHandle : ''),
      collectorUrl: String((collector && collector.collectorUrl) || '').trim(),
    };
  }

  function formatMoney(value) {
    var amount = Number(value || 0);
    return 'HKD ' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function formatKrwMoney(value) {
    var amount = Number(value || 0) * 180;
    return 'KRW ₩' + Math.round(amount).toLocaleString('ko-KR');
  }

  function getFirstAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    return (
      variants.find(function (variant) {
        return Boolean(variant && variant.available);
      }) ||
      variants[0] ||
      null
    );
  }

  function hasAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];

    return variants.some(function (variant) {
      return Boolean(variant && variant.available);
    });
  }

  function isPickProduct(product) {
    return /pick/i.test(String((product && product.title) || ''));
  }

  function getVariantIds(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];

    return variants
      .map(function (variant) {
        return variant && variant.id != null ? String(variant.id).trim() : '';
      })
      .filter(Boolean)
      .join(',');
  }

  function fetchJson(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HOME_PRODUCTS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('PRODUCT_HTML_REQUEST_FAILED');
      }

      return response.text();
    });
  }

  function getText(node) {
    return node && typeof node.textContent === 'string' ? node.textContent.trim() : '';
  }

  function parseCollectorData(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var followButton = doc.querySelector('.js-follow-btn[data-influencer-handle]');
    var nameNode = doc.querySelector('.imini__nm a, .imini__nm');
    var linkNode = doc.querySelector('.imini__nm a');
    var metaSpans = Array.prototype.slice.call(doc.querySelectorAll('.imini__h span'));
    var handleLabel = '';

    metaSpans.some(function (node) {
      var value = getText(node);

      if (value.indexOf('@') === 0) {
        handleLabel = value;
        return true;
      }

      return false;
    });

    var followHandle = normalizeHandle(
      followButton instanceof HTMLElement ? followButton.dataset.influencerHandle || '' : '',
    );
    var displayName = getText(nameNode);
    var supplierMeta = getText(doc.querySelector('.deal-h .imini__h'));

    return {
      followHandle: followHandle,
      followName:
        (followButton instanceof HTMLElement && followButton.dataset.influencerName) ||
        displayName ||
        '',
      displayName: displayName,
      handleLabel: handleLabel,
      collectorUrl:
        linkNode instanceof HTMLAnchorElement ? linkNode.getAttribute('href') || '' : '',
      supplierMeta: supplierMeta,
    };
  }

  function createImageMarkup(product) {
    var image = Array.isArray(product.images) && product.images.length ? product.images[0] : null;

    if (!image || !image.src) {
      return '<div class="tw-card-fallback" aria-hidden="true"></div>';
    }

    return (
      '<img src="' +
      escapeHtml(image.src) +
      '" class="tw-card-image" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy">'
    );
  }

  function resolveHomeFeedLabels(recommendationPanel, collectorGrid) {
    var recommendationData = (recommendationPanel && recommendationPanel.dataset) || {};
    var collectorData = (collectorGrid && collectorGrid.dataset) || {};

    return {
      followLabel: FOLLOW_LABEL,
      followingLabel: FOLLOWING_LABEL,
      unassignedCollectorLabel:
        recommendationData.unassignedCollectorLabel || '컬렉터 미지정',
      inventorySummaryLoadingLabel:
        recommendationData.inventorySummaryLoadingLabel || '판매 수량 확인 중',
      inventoryCaptionLoadingLabel:
        recommendationData.inventoryCaptionLoadingLabel || '재고 정보 확인 중',
      recommendationCtaLabel: recommendationData.ctaLabel || '딜 자세히 보기',
      collectorEmptyLabel: collectorData.emptyLabel || LIVE_COLLECTOR_EMPTY_MESSAGE,
      collectorLiveLabel: collectorData.liveLabel || '진행 중',
      collectorLoadingFollowersLabel:
        collectorData.loadingFollowersLabel || '집계 중',
      collectorLoadingDealsLabel: collectorData.loadingDealsLabel || '집계 중',
      collectorsPageUrl: collectorData.collectorsPageUrl || '/pages/collectors',
    };
  }

  function buildFollowButton(collector, proxyBase, labels) {
    if (!collector.followHandle) {
      return '';
    }

    var followLabel = (labels && labels.followLabel) || FOLLOW_LABEL;
    var followingLabel = (labels && labels.followingLabel) || FOLLOWING_LABEL;

    return (
      '<button class="follow js-follow-btn" type="button" ' +
      'onclick="if (event) { event.__townwineFollowHandled = true; } if (window.TownWineFollow && typeof window.TownWineFollow.handleButtonClick === \'function\') { window.TownWineFollow.handleButtonClick(this, event); }" ' +
      'data-influencer-handle="' +
      escapeHtml(collector.followHandle) +
      '" ' +
      'data-influencer-name="' +
      escapeHtml(collector.followName || collector.displayName || '') +
      '" ' +
      'data-proxy-base="' +
      escapeHtml(proxyBase) +
      '" ' +
      'data-follow-label="' +
      escapeHtml(followLabel) +
      '" ' +
      'data-following-label="' +
      escapeHtml(followingLabel) +
      '" ' +
      'data-return-to="' +
      escapeHtml(window.location.pathname + window.location.search + window.location.hash) +
      '" ' +
      'aria-pressed="false">' +
      escapeHtml(followLabel) +
      '</button>'
    );
  }

  function buildRecommendationCard(product, collector, proxyBase, labels) {
    var variant = getFirstAvailableVariant(product);

    if (!variant) {
      return '';
    }

    var hasCollector = Boolean(collector && (collector.followHandle || collector.displayName));
    var mainName = hasCollector
      ? collector.displayName || collector.followName
      : labels.unassignedCollectorLabel;
    var subLine = hasCollector
      ? [product.vendor, collector.handleLabel].filter(Boolean).join(' · ')
      : product.vendor || '';
    var profileUrl = hasCollector && collector.collectorUrl ? collector.collectorUrl : '';
    var initial = (mainName || product.vendor || '?').slice(0, 1);
    var subtitle = [product.product_type || 'Curated wine', product.vendor || '']
      .filter(Boolean)
      .join(' · ');
    var infoOpen = profileUrl ? '<a class="dc__ii" href="' + escapeHtml(profileUrl) + '">' : '<div class="dc__ii">';
    var infoClose = profileUrl ? '</a>' : '</div>';
    var variantIds = getVariantIds(product);

    return (
      '<article class="dc" data-townwine-product-card-url="/products/' +
      escapeHtml(product.handle) +
      '">' +
      '<a class="dc__m dc__m-link" href="/products/' +
      escapeHtml(product.handle) +
      '" aria-label="' +
      escapeHtml(product.title) +
      '">' +
      createImageMarkup(product) +
      '</a>' +
      '<div class="dc__bd">' +
      '<div class="dc__inf">' +
      infoOpen +
      '<span class="mini">' +
      escapeHtml(initial) +
      '</span>' +
      '<div class="dc__nm">' +
      escapeHtml(mainName) +
      '<span>' +
      escapeHtml(subLine) +
      '</span></div>' +
      infoClose +
      buildFollowButton(collector, proxyBase, labels) +
      '</div>' +
      '<div><h3 class="dc__t"><a href="/products/' +
      escapeHtml(product.handle) +
      '">' +
      escapeHtml(product.title) +
      '</a><em>' +
      escapeHtml(subtitle) +
      '</em></h3></div>' +
      '<div class="pg" data-townwine-inventory-card data-variant-id="' +
      escapeHtml(variant.id) +
      '" data-variant-ids="' +
      escapeHtml(variantIds) +
      '" data-proxy-base="' +
      escapeHtml(proxyBase) +
      '">' +
      '<div class="pg__bar"><div class="pg__fl" style="width:0%" data-inventory-progress-bar></div></div>' +
      '<div class="pg__mt"><span data-inventory-summary>' +
      escapeHtml(labels.inventorySummaryLoadingLabel) +
      '</span><span data-inventory-caption>' +
      escapeHtml(labels.inventoryCaptionLoadingLabel) +
      '</span></div>' +
      '</div>' +
      '<div class="pr"><div class="pr__main"><span class="now">' +
      escapeHtml(formatMoney(variant.price)) +
      '</span></div><div class="pr__sub">' +
      escapeHtml(formatKrwMoney(variant.price)) +
      '</div></div>' +
      '<a class="btn btn--dark btn--block dc__cta" href="/products/' +
      escapeHtml(product.handle) +
      '">' +
      escapeHtml(labels.recommendationCtaLabel) +
      '</a>' +
      '</div></article>'
    );
  }

  function buildCollectorCard(collector, proxyBase, labels) {
    if (!collector || !collector.followHandle) {
      return '';
    }

    var displayName = collector.displayName || collector.followName || collector.followHandle;
    var profileUrl = collector.collectorUrl || labels.collectorsPageUrl;
    var initial = displayName.slice(0, 1);

    return (
      '<article class="inf-card">' +
      '<a class="inf-card__body" href="' +
      escapeHtml(profileUrl) +
      '">' +
      '<div class="av av--live">' +
      escapeHtml(initial) +
      '</div>' +
      '<div class="inf-card__n">' +
      escapeHtml(displayName) +
      '</div>' +
      '<div class="inf-card__live">' +
      escapeHtml(labels.collectorLiveLabel) +
      '</div>' +
      '<div class="inf-card__f" data-townwine-collector-summary data-influencer-handle="' +
      escapeHtml(collector.followHandle) +
      '" data-proxy-base="' +
      escapeHtml(proxyBase) +
      '" data-loading-followers-label="' +
      escapeHtml(labels.collectorLoadingFollowersLabel) +
      '" data-loading-deals-label="' +
      escapeHtml(labels.collectorLoadingDealsLabel) +
      '">' +
      '<span data-collector-followers>' +
      escapeHtml(labels.collectorLoadingFollowersLabel) +
      '</span><span aria-hidden="true">·</span><span data-collector-deals>' +
      escapeHtml(labels.collectorLoadingDealsLabel) +
      '</span>' +
      '</div>' +
      '</a>' +
      buildFollowButton(
        {
          followHandle: collector.followHandle,
          followName: displayName,
        },
        proxyBase,
        labels,
      ) +
      '</article>'
    );
  }

  async function fetchLatestProducts() {
    var payload = await fetchJson(PRODUCTS_ENDPOINT);
    var products = Array.isArray(payload && payload.products) ? payload.products : [];
    return products
      .filter(function (product) {
        return isPickProduct(product) && hasAvailableVariant(product);
      })
      .sort(function (left, right) {
        return new Date(right.created_at || 0).getTime() - new Date(left.created_at || 0).getTime();
      });
  }

  async function fetchCollectorDetails(products) {
    var details = new Map();

    await Promise.all(
      products.map(async function (product) {
        try {
          var html = await fetchText('/products/' + product.handle + '?view=default');
          details.set(product.handle, parseCollectorData(html));
        } catch (error) {
          console.warn('[townwine-home-live-feed] failed to fetch product detail', product.handle, error);
          details.set(product.handle, {
            followHandle: '',
            followName: '',
            displayName: '',
            handleLabel: '',
            collectorUrl: '',
          });
        }
      }),
    );

    return details;
  }

  function replaceRecommendationPanel(root, products, details, proxyBase, labels) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    var recommendations = products
      .slice(0, MAX_RECOMMENDATIONS)
      .map(function (product) {
        return buildRecommendationCard(product, details.get(product.handle) || {}, proxyBase, labels);
      })
      .filter(Boolean);

    if (!recommendations.length) {
      root.dataset.liveFeedReady = 'true';
      root.removeAttribute('aria-busy');
      return;
    }

    root.innerHTML = recommendations.join('');
    root.dataset.resultCount = String(products.length);
    root.dataset.liveFeedReady = 'true';
    root.removeAttribute('aria-busy');

    bootInteractiveWidgets(root);
  }

  function replaceCollectorGrid(root, products, details, proxyBase, labels) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    var collectorCards = [];
    var seenCollectorKeys = new Set();

    products.some(function (product) {
      var collector = resolveCollectorIdentity(details.get(product.handle) || {});
      var collectorKey = collector.dedupeKey;

      if (!collectorKey || seenCollectorKeys.has(collectorKey)) {
        return false;
      }

      var collectorCardMarkup = buildCollectorCard(
        {
          followHandle: collector.followHandle,
          followName: collector.followName || collector.displayName,
          displayName: collector.displayName || collector.followName,
          handleLabel: collector.handleLabel,
          collectorUrl: collector.collectorUrl,
        },
        proxyBase,
        labels,
      );

      if (!collectorCardMarkup) {
        return false;
      }

      seenCollectorKeys.add(collectorKey);
      collectorCards.push(collectorCardMarkup);

      return collectorCards.length >= MAX_COLLECTORS;
    });

    if (!collectorCards.length) {
      root.innerHTML =
        '<p class="inf-empty">' +
        escapeHtml(labels.collectorEmptyLabel) +
        '</p>';
      return;
    }

    root.innerHTML = collectorCards.join('');

    bootInteractiveWidgets(root);
  }

  function hydrateCollectorGrid(root, labels) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    if (!root.textContent.trim()) {
      root.innerHTML =
        '<p class="inf-empty">' +
        escapeHtml(labels.collectorEmptyLabel) +
        '</p>';
    }

    bootInteractiveWidgets(root);
  }

  function hasServerRenderedContent(root, selector) {
    return root instanceof HTMLElement && Boolean(root.querySelector(selector));
  }

  function getServerRenderedRecommendationCards(root) {
    if (!(root instanceof HTMLElement)) {
      return [];
    }

    return Array.prototype.slice.call(root.querySelectorAll('[data-townwine-product-card-url]'));
  }

  function getExpectedServerRenderedRecommendationCount(root) {
    if (!(root instanceof HTMLElement)) {
      return MAX_RECOMMENDATIONS;
    }

    var resultCount = Number(root.dataset.resultCount || 0);

    if (!Number.isFinite(resultCount) || resultCount < 0) {
      return MAX_RECOMMENDATIONS;
    }

    return Math.min(MAX_RECOMMENDATIONS, Math.trunc(resultCount));
  }

  function shouldKeepServerRenderedRecommendations(root) {
    var cards = getServerRenderedRecommendationCards(root);
    var expectedCount = getExpectedServerRenderedRecommendationCount(root);

    if (!cards.length) {
      return false;
    }

    if (cards.length < expectedCount) {
      return false;
    }

    return cards.every(function (card) {
      var titleNode = card.querySelector('.dc__t a');
      return isPickProduct({ title: getText(titleNode) });
    });
  }

  function shouldKeepServerRenderedCollectors(root) {
    if (!(root instanceof HTMLElement)) {
      return false;
    }

    return hasServerRenderedContent(
      root,
      '.inf-card, [data-townwine-collector-summary], .inf-empty',
    );
  }

  async function initHomeLiveFeed() {
    var recommendationPanel = document.querySelector('[data-home-live-recommendations]');
    var collectorGrid = document.querySelector('[data-home-live-collectors]');

    if (!(recommendationPanel instanceof HTMLElement) || !(collectorGrid instanceof HTMLElement)) {
      return;
    }

    recommendationPanel.dataset.liveFeedReady = 'false';
    recommendationPanel.setAttribute('aria-busy', 'true');

    var proxyBase =
      recommendationPanel.dataset.proxyBase ||
      collectorGrid.dataset.proxyBase ||
      DEFAULT_PROXY_BASE;
    var labels = resolveHomeFeedLabels(recommendationPanel, collectorGrid);

    if (
      shouldKeepServerRenderedRecommendations(recommendationPanel) &&
      shouldKeepServerRenderedCollectors(collectorGrid)
    ) {
      recommendationPanel.dataset.liveFeedReady = 'true';
      recommendationPanel.removeAttribute('aria-busy');
      bootInteractiveWidgets(recommendationPanel);
      bootInteractiveWidgets(collectorGrid);
      return;
    }

    try {
      var latestProducts = await fetchLatestProducts();
      var fetchedProducts = latestProducts.slice(0, MAX_PRODUCT_FETCH);
      var collectorDetails = await fetchCollectorDetails(fetchedProducts);

      replaceRecommendationPanel(recommendationPanel, latestProducts, collectorDetails, proxyBase, labels);
      replaceCollectorGrid(collectorGrid, latestProducts, collectorDetails, proxyBase, labels);

    } catch (error) {
      console.error('[townwine-home-live-feed] failed to hydrate home feed', error);
      recommendationPanel.dataset.liveFeedReady = 'true';
      recommendationPanel.removeAttribute('aria-busy');
      hydrateCollectorGrid(collectorGrid, labels);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeLiveFeed, { once: true });
  } else {
    initHomeLiveFeed();
  }
})();
